import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from "@angular/router";
import { Injectable } from "@angular/core";

@Injectable()
export class CustomReuseStrategy implements RouteReuseStrategy {

    handlers: { [key: string]: DetachedRouteHandle } = {};

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        let detach: boolean = route.data.canReuse;
        return detach; 
    }

    store(route: ActivatedRouteSnapshot, handle: {}): void {
        this.handlers[route.url.join("/") || route.parent.url.join("/")] = handle;
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        let url = route.url.join("/") || route.parent.url.join("/")
        return !!this.handlers[url];
    }

    retrieve(route: ActivatedRouteSnapshot): {} {
        return this.handlers[route.url.join("/") || route.parent.url.join("/")];
    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return future.routeConfig === curr.routeConfig;
    }

}